import React from "react";
import classes from './Policies.module.css';
import Footer from "../../components/footer/Footer";

const Policies = () => {
    return (
        <div className={classes.Container}>
            <div className={classes.Primary}>
                <div className={classes.ContainerInner}>
                    <div className={classes.Column}>
                        <div className={classes.Section}>
                            <div className={classes.Title}>Fill Policy</div>
                            <div className={classes.Paragraph}>
                                Please schedule your appointments accordingly to allow for adequate fill time! I want to get your lashes as full as possible! For a normal (2 week) fill, you should have 80% or more lashes. Otherwise your fill may be considered an extended fill or even a full set.
                            </div>
                            <div className={classes.Paragraph}>
                                Note: If you're unsure what fill is right for you feel free to send photos to my <a href='https://www.instagram.com/pristine.lash/' target={'_blank'}>Instagram</a>! (Responses within 24hrs).
                            </div>
                        </div>
                        <div className={classes.Section}>
                            <div className={classes.Title}>Late Policy</div>
                            <div className={classes.Paragraph}>
                                I understand life happens, emergencies come up, and try to be as understanding as possible. However, when one client is late, it can affect the rest of the scheduled appointments. So with that in mind, PLEASE plan accordingly and arrive 5-10 minutes PRIOR to your appointment start time. There will be a 10 minutes grace period before you will be charged a $5 late fee. Anything over 15 minutes will be considered a no show your appointment will be cancelled.
                            </div>
                        </div>
                    </div>
                    <div className={classes.Column}>
                        <div className={classes.Section}>
                            <div className={classes.Title}>Cancellation Policy</div>
                            <div className={classes.Paragraph}>
                                Your appointment time is reserved just for you! A last minute cancellation or no show leaves a
                                gap in my schedule that could have been filled by another client. So please cancel or
                                reschedule your appointment at least 48 hours in advance. Any cancellations or no shows beyond
                                that are subject to a 50% service charge.
                            </div>
                        </div>
                        <div className={classes.Section}>
                            <div className={classes.Title}>Refund policy</div>
                            <div className={classes.Paragraph}>
                                I want all my clients to love their lashes! If you want to change or fix your lashes I offer
                                a free 30 minute fill, if notified within 24 hrs of your initial service. However, all service
                                costs and payments are final.
                            </div>
                        </div>
                    </div>
                    <div className={classes.Column}>
                        <div className={classes.Section}>
                            <div className={classes.Title}>Live, lash, love</div>
                            <div className={classes.Paragraph}>
                                My main goal, other than to provide you with the pristine lashes possible, is to provide you
                                with the very best experience! Trust me, I am all about building fun client relationships,
                                but I do ask that you respect me, my time and professional space! Misconduct will not be tolerated
                                and will result in termination of future appointments. We are both here because of our love for lashes,
                                so lets have a good time!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.FooterWrapper}>
                <Footer />
            </div>
        </div>
    )
}

export default Policies;
